import _classCallCheck from "/Users/db/Projects/agora/agora-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/db/Projects/agora/agora-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/createClass";
var VideoElementCreatorFactory = /*#__PURE__*/function () {
  function VideoElementCreatorFactory(escapeHtml) {
    _classCallCheck(this, VideoElementCreatorFactory);
    this.escapeHtml = escapeHtml;
    this.create = this.create.bind(this);
  }
  return _createClass(VideoElementCreatorFactory, [{
    key: "create",
    value: function create(tokens, idx) {
      var url = this.escapeHtml(tokens[idx].videoUrl);
      var videoElement = "<div data-vjs-player style=\"max-width: 100%\">\n      <video\n        style=\"max-width: 100%\"\n        class=\"video-js hm-video-js\"\n        controls\n        preload=\"auto\"\n      >\n        <source src=\"".concat(url, "\" type=\"video/mp4\" />\n      </video>\n    </div>");
      return videoElement;
    }
  }]);
}();
export { VideoElementCreatorFactory as default };